/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Na_BroadcastInputs */



/**
* | output |
* | --- |
* | "North American Broadcast" |
*
* @param {Standards_Preset_Na_BroadcastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_na_broadcast = /** @type {((inputs?: Standards_Preset_Na_BroadcastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Na_BroadcastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "de") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "it") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "ru") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "es") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "ja") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "hi") return /** @type {LocalizedString} */ ("North American Broadcast")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("North American Broadcast")
	return /** @type {LocalizedString} */ ("North American Broadcast")
});